import React from 'react';

function Singapore(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124003)">
        <mask
          id="mask0_800_124003"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124003)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124003"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124003)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V12H36V0H0Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.97715 10.5896C9.97715 10.5896 6.79825 9.4531 6.79825 6.37402C6.79825 3.29495 9.97715 2.19517 9.97715 2.19517C8.43215 1.8475 4.33252 2.15846 4.33252 6.37402C4.33252 10.5896 8.3702 11.3846 9.97715 10.5896ZM10.7916 10.0807L11.7036 9.59128L12.6356 10.0807L12.4075 9.12569L13.1652 8.37235H12.1386L11.7036 7.48065L11.2685 8.37235L10.2402 8.41099L10.9996 9.12569L10.7916 10.0807ZM15.0181 9.53662L14.1062 10.026L14.3142 9.07103L13.5548 8.35634L14.5831 8.31769L15.0181 7.42599L15.4532 8.31769H16.4798L15.7221 9.07103L15.9502 10.026L15.0181 9.53662ZM12.6983 5.76989L13.6102 5.28052L14.5423 5.76989L14.3142 4.81493L15.0719 4.06159H14.0453L13.6102 3.16989L13.1752 4.06159L12.1469 4.10023L12.9063 4.81493L12.6983 5.76989ZM10.5412 7.22266L9.62926 7.71203L9.83727 6.75707L9.07784 6.04237L10.1061 6.00373L10.5412 5.11203L10.9763 6.00373H12.0028L11.2452 6.75707L11.4733 7.71203L10.5412 7.22266ZM15.6575 7.66818L16.5694 7.1788L17.5015 7.66818L17.2733 6.71321L18.031 5.95988H17.0045L16.5694 5.06818L16.1343 5.95988L15.106 5.99852L15.8655 6.71321L15.6575 7.66818Z"
              fill="#F1F9FF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124003">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Singapore;
